import * as React from 'react';

export interface OrderInfoItemProps {
  label: string;
  value: string;
}

export const OrderInfoItem: React.FC<OrderInfoItemProps> = ({
  label,
  value,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <dt className="text-sm leading-4 text-gray-500">{label}</dt>
      <dd className="text-base font-bold leading-5 text-zinc-800">{value}</dd>
    </div>
  );
};
